/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu June 15 2021 14:30:00 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getThemes } from 'actions/theme-setup-actions';

import Condition1Content from 'src/components/views/common/theme-upgrade-flow-2-notification/condition-1';
import Condition3Content from 'src/components/views/common/theme-upgrade-flow-2-notification/condition-3';

type Props = {
  featureID: String,
  tenantApp: Object,
  emailSupport: string,
  existedThemeLibV2: boolean,
  themesLoading: boolean,
  getThemes: () => void
};

const ThemeUpgradeFlow2Notification: React.FC<Props> = ({
  featureID,
  tenantApp,
  emailSupport,
  existedThemeLibV2,
  themesLoading,
  getThemes
}) => {
  const {
    liveThemeV2 = false,
    liveThemeV3 = false,
    adminAppFeatures = {},
    upgradeThemeV2 = {}
  } = tenantApp;
  const { themeSetupV2 = false } = adminAppFeatures;
  const { installStatus = '', upgradeUsingThemeSetup = false } = upgradeThemeV2;

  // Turn on theme V2, but not publish v2 and v3 => Show banner
  const enableBanner = !liveThemeV2 && themeSetupV2 && !liveThemeV3 && !themesLoading;

  const contentProps = { featureID, emailSupport };

  let Content = null;
  if (existedThemeLibV2) {
    if (installStatus === 'success') {
      // Condition 1
      Content = <Condition1Content />;
    } else if (upgradeUsingThemeSetup) {
      // Condition 3
      Content = <Condition3Content />;
    }
  } else {
    // Condition 2 and 4
    // Content = <Condition2And4Content />;
    Content = null;
  }

  useEffect(() => {
    getThemes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!enableBanner || !Content) return null;

  return React.cloneElement(Content, contentProps);
};

const mapStateToProps = state => ({
  tenantApp: _.get(state.oauth, 'tenantApp', {}),
  existedThemeLibV2: _.get(state.themeSetup, 'existedThemeLibV2', false),
  themesLoading: _.get(state.themeSetup, 'getThemesLoading', false),
  emailSupport: _.get(state.oauth, 'emailSupport')
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getThemes: () => dispatch(getThemes(ownProps.i18n, true))
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemeUpgradeFlow2Notification);
